<div class="app-container">
  <loading-spinner [isLoading]="productDetailService.loading" [classesString]="'top-25'"></loading-spinner>
  <page-header
    *ngIf="productDetailService.isCreating || product"
    [icon]="'far-cube'"
    [title]="
      isProductTemplateSelectionPage
        ? ('product.template-selection' | translate)
        : !isProductTemplateSelectionPage && productDetailService.isCreating
          ? 'product.new'
          : ''
    "
    [appendNoTranslationTitlePart]="productDetailService.isCreating ? '' : product.name"
    [isOnProductWithAllBtns]="
      product &&
      product.id > 0 &&
      (!product.children || (product.children && product.children.length === 0)) &&
      !productDetailService.isCreating &&
      product.isDeletable
    "
  >
    <ng-container class="header-button">
      <div class="row">
        <div class="col-12 d-flex align-items-center flex-row-reverse">
          <btn
            *ngIf="
              !isProductTemplateSelectionPage &&
              (productDetailService.isCreating ||
                (!productDetailService.isCreating && productDetailService.hasUpdateRole))
            "
            [btnType]="'submit'"
            [classes]="['btn-first', 'float-right']"
            [label]="'save'"
            [title]="'save' | translate"
            [icon]="'far-check'"
            (onEvent)="productDetailService.isCreating ? createProduct() : updateProduct()"
            [isLoading]="productDetailService.loading"
            [spinnerClassesString]="'spinner-white'"
            data-cy="added-product"
          ></btn>
          <btn
            *ngIf="
              productDetailService.hasDeleteRole &&
              !productDetailService.isCreating &&
              productDetailService.product.isDeletable
            "
            [btnType]="'button'"
            [classes]="[
              product.children && product.children.length > 0 ? 'd-none' : '',
              'btn-first-red',
              'float-right',
              'mr-2',
            ]"
            [btnDisabled]="productDetailService.loading"
            [label]="'delete'"
            [icon]="'far-trash-alt'"
            data-cy="delete-product"
            [title]="'delete' | translate"
            (onEvent)="deleteProduct()"
          ></btn>
          <btn
            *ngIf="productDetailService.isCreating && isProductTemplateSelectionPage"
            [icon]="'far-arrow-right'"
            [label]="productDetailService.isProductFromTemplate ? 'continue' : 'product.continueWithoutTemplate'"
            [title]="
              productDetailService.isProductFromTemplate
                ? ('continue' | translate)
                : ('product.continueWithoutTemplate' | translate)
            "
            [btnDisabled]="!isProductTemplateSelectionPage"
            [classes]="['btn-first', 'float-right']"
            (onEvent)="triggerNextStep()"
            data-cy="continue"
          ></btn>

          <modal-stock-load
            *ngIf="
              !isProductTemplateSelectionPage &&
              productDetailService.hasStockOperationInRole &&
              product &&
              product.id > 0 &&
              (!product.children || (product.children && product.children.length === 0))
            "
            [product]="product"
            [depots]="productDetailService.depots"
            [suppliers]="productDetailService.suppliers"
            (result)="resolveStockLoad()"
            [currencies]="productDetailService.currencies"
          ></modal-stock-load>
          <!--          todo: this `(router.url.includes('common') || product.id)` will be a conflict on staging merge. prefer staging then-->
          <form-row-toggle
            *ngIf="isBatchlessModeEnabled && product && (router.url.includes('common') || product.id)"
            [label]="'record-batches'"
            class="float-right mr-3"
            [model]="product.enabledBatchExpiration"
            (modelChange)="product.enabledBatchExpiration = $event"
          ></form-row-toggle>
        </div>
      </div>
    </ng-container>

    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'mr-2']"
        [icon]="'far-arrow-left'"
        (onEvent)="triggerBackBtn()"
      ></btn>
    </ng-container>
  </page-header>

  <section *ngIf="isProductTemplateSelectionPage" class="content">
    <loading-spinner
      [isLoading]="productDetailService.loading && (!product || (product && product.id > 1))"
      [classesString]="'top-50'"
    ></loading-spinner>
    <ng-container>
      <app-product-template-selection
        [isCreating]="productDetailService.isCreating"
        [loading]="productDetailService.loading"
        (templateSelected)="productTemplateSelected($event)"
      >
      </app-product-template-selection>
    </ng-container>
  </section>

  <section
    class="content"
    *ngIf="!isProductTemplateSelectionPage && !productDetailService.loading && !!productDetailService.product"
  >
    <nav class="tab-container" type="pills">
      <ul role="tablist" class="nav nav-pills">
        <li class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'common'"
            [ngClass]="activeLink === 'common' ? 'active' : ''"
            class="nav-link"
            [routerLink]="productDetailService.isCreating ? '/product/common' : '/product/' + product.id"
            [replaceUrl]="true"
            >{{ 'product.tab.common' | translate }}</a
          >
        </li>
        <li *ngIf="!productDetailService.isCreating" class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'stock'"
            [ngClass]="activeLink === 'stock' ? 'active' : ''"
            class="nav-link"
            routerLink="stock"
            [replaceUrl]="true"
            >{{ 'product.tab.stock' | translate }}</a
          >
        </li>
        <li *ngIf="!productDetailService.isCreating" class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'moves'"
            [ngClass]="activeLink === 'moves' ? 'active' : ''"
            class="nav-link"
            routerLink="moves"
            [replaceUrl]="true"
            >{{ 'product.tab.moves' | translate }}</a
          >
        </li>
        <li *ngIf="!productDetailService.isCreating" class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'images'"
            [ngClass]="activeLink === 'images' ? 'active' : ''"
            class="nav-link"
            routerLink="images"
            [replaceUrl]="true"
            >{{ 'product.tab.images' | translate }}</a
          >
        </li>
        <li *ngIf="!productDetailService.isCreating && product?.externalId" class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'files'"
            [ngClass]="activeLink === 'files' ? 'active' : ''"
            class="nav-link"
            routerLink="files"
            [replaceUrl]="true"
            >{{ 'product.tab.files' | translate }}</a
          >
        </li>
        <li class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'categories'"
            [ngClass]="activeLink === 'categories' ? 'active' : ''"
            class="nav-link"
            routerLink="categories"
            [replaceUrl]="true"
            >{{ 'product.tab.categories' | translate }}</a
          >
        </li>
        <li class="nav-item product-tab-heading">
          <a
            (click)="activeLink = 'packing'"
            [ngClass]="activeLink === 'packing' ? 'active' : ''"
            class="nav-link"
            routerLink="packing"
            [replaceUrl]="true"
            >{{ 'product.tab.packing' | translate }}</a
          >
        </li>
        <li
          *ngIf="!productDetailService.isCreating && automaticOrdersSettings.automatizationLevel !== 'none'"
          class="nav-item product-tab-heading"
        >
          <a
            (click)="activeLink = 'automatic-ordering'"
            [ngClass]="activeLink === 'automatic-ordering' ? 'active' : ''"
            class="nav-link"
            routerLink="automatic-ordering"
            [replaceUrl]="true"
            >{{ 'product.tab.automatic-ordering' | translate }}</a
          >
        </li>
      </ul>
    </nav>
    <router-outlet></router-outlet>
  </section>
</div>
